module.exports = __webpack_public_path__ + "img/meet_logo.d81466a5.png";